module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAjCAYAAACZ6FpfAAAACXBIWXMAAAsSAAALEgHS3X78AAAA5UlEQVRIx+2WsQ3CMBBFn1F6HBgACkqKsEGYAMrQmRGQkj69GzYgVG4ZATZgAAomsLKBaYwUoSCkJB2+xjr769n/mm/hnGOIEnGWK+AIjDsybsA28pCLNVo1Tye7QgJza/T9G2GyKxLgCigRZ7mzRosW0RVYAtPG9t4aXX3oyrc1B6xbLlz49fHDmgLqyDdljzknwD0CsEanXSl+BIwYqAIogAIogALoD0GRj5S0B0MOFZASeA4RkGXTmrRG1y2iC7Dx7erLz0QCtYiz/AnUQNoG+/EaBZyAg4izPAUqYNbR3dkarV6I30MNdJwIjAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile.png
// module id = 587
// module chunks = 0